import ProAccCover from "./ProAccCover"

export default ProAccCover
